// extracted by mini-css-extract-plugin
export default {"userProfileContainer":"HelpDoc_userProfileContainer__0hPmJ","iconItem":"HelpDoc_iconItem__37MY8","optionIcon":"HelpDoc_optionIcon__Cq3NC"};